// Centralized auth route guards with no imports from launch-routes to avoid circular deps.
import Vue from "vue";
import { getStore } from "../common/runtime-context";
import { CONFIG_STORE_CONST, IConfigStoreState } from "../config/config-store";
import { ConfigData } from "../config/config-data";
import { handleResponseMessages } from "../common/handle-http-reponse";
import { messageDispatchHelper } from "../user-message/user-message-store";
import { USER_MESSAGE_LEVEL } from "../user-message/user-message-models";
import { AUTH_STORE_CONST } from "../auth/auth-store";

// Generic guard logic (no dependency on route constants)
export function isLoggedInGuardGeneric(to: any, next: any, loginRoute: string) {
  // Set document title from route meta
  Vue.nextTick(() => {
    const title: unknown = to.meta && to.meta.title ? to.meta.title : null;
    if (title) {
      if (typeof title === "string") {
        document.title = title;
        return;
      }
      if (typeof title === "function") {
        document.title = title(to.params);
        return;
      }
    }
    document.title = "Entry4Sports";
  });

  let isUserLoggedIn = false;
  const store = getStore();
  
  if (!store) {
    // Store not initialized yet, allow navigation to continue
    next();
    return;
  }
  
  const configStoreState: IConfigStoreState =
    store.state[CONFIG_STORE_CONST.CONFIG_CONST_MODULE_NAME];
  const userName = configStoreState?.configApp?.userInfo?.user?.display_name;

  if (userName === "" || userName === "ANONYMOUS") {
    // Not initialized; fetch app config and then decide
    const prom = new ConfigData().getAppConfig();
    handleResponseMessages(prom);
    prom.then((response) => {
      if (response.errNo > 0) {
        messageDispatchHelper(
          response.error,
          USER_MESSAGE_LEVEL.ERROR.toString()
        );
        return;
      }
      store.commit(
        CONFIG_STORE_CONST.CONFIG_CONST_MODULE_NAME +
          "/" +
          CONFIG_STORE_CONST.CONFIG_MUTATIONS_SET_APP_CONFIG,
        response.data
      );
      const userNameData = response.data.userInfo.user.display_name;
      const isLoggedIn = userNameData.replace("ANONYMOUS", "").length > 0;
      store.commit(
        AUTH_STORE_CONST.AUTH_CONST_MODULE_NAME +
          "/" +
          AUTH_STORE_CONST.MUTATIONS_LOGGED_IN,
        isLoggedIn
      );
      if (isLoggedIn) {
        next();
      } else {
        next({
          name: loginRoute,
          query: {
            redirectFrom: to.fullPath,
          },
        });
      }
    });
    return;
  } else {
    isUserLoggedIn = true;
  }

  if (!isUserLoggedIn) {
    next({
      name: loginRoute,
      query: {
        redirectFrom: to.fullPath,
      },
    });
    return;
  } else {
    next();
  }
  next();
}

// Factory to create a guard bound to a given login route name
export function makeLoginGuard(loginRouteName: string) {
  return (to: any, _from: any, next: any) =>
    isLoggedInGuardGeneric(to, next, loginRouteName);
}